import React from "react";
import { Button, Modal } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

const StatusChangeModal = ({
  show,
  setShow,
  handleYes,
  active,
  selectedStaff,
  loading,
}) => {
  const isDeactivating = active;

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      centered
      backdrop="static"
      style={{
        backdropFilter: "blur(15px)",
        WebkitBackdropFilter: "blur(15px)",
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {isDeactivating ? "Deactivate Staff" : "Activate Staff"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="mb-3">
          {isDeactivating
            ? `Deactivate ${selectedStaff?.name || "this staff member"
            }? They will lose system access immediately.`
            : `Activate ${selectedStaff?.name || "this staff member"
            }? They will regain system access.`}
        </p>

        {selectedStaff?.email && (
          <div className="bg-light p-3 rounded">
            <strong>{selectedStaff.name}</strong>
            <br />
            <small className="text-muted">{selectedStaff.email}</small>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => setShow(false)}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          variant={isDeactivating ? "warning" : "success"}
          onClick={handleYes}
          disabled={loading}
        >
          {loading
            ? "Processing..."
            : isDeactivating
              ? "Deactivate"
              : "Activate"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const DeleteModal = ({
  show,
  setShow,
  handleDeleteYes,
  selectedStaff,
  loading,
}) => {
  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      centered
      backdrop="static"
      style={{
        backdropFilter: "blur(15px)",
        WebkitBackdropFilter: "blur(15px)",
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title className="text-danger">Delete Staff</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="mb-3">
          Permanently delete{" "}
          <strong>{selectedStaff?.name || "this staff member"}</strong>? This
          action cannot be undone.
        </p>

        <div className="alert alert-danger">
          <small>
            <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
            <span>
              All staff data and access will be permanently removed.
            </span>
          </small>
        </div>

        {selectedStaff?.email && (
          <div className="bg-light p-3 rounded">
            <strong>{selectedStaff.name}</strong>
            <br />
            <small className="text-muted">{selectedStaff.email}</small>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => setShow(false)}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button variant="danger" onClick={handleDeleteYes} disabled={loading}>
          {loading ? "Deleting..." : "Delete Permanently"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export { StatusChangeModal, DeleteModal };
